import React, { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { Typography, Button, message, Spin } from "antd";
import { ArrowLeftOutlined, SettingOutlined } from "@ant-design/icons";
import WarehouseInventoryManager from "../components/WarehouseInventoryManager";
import warehouseApi from "../api/warehouseApi";
import "./WarehouseInventoryPage.scss";

const { Text, Title } = Typography;

const WarehouseInventoryPage = () => {
  const { inventoryId: warehouseId } = useParams();
  const history = useHistory();
  const [warehouse, setWarehouse] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadWarehouse();
  }, [warehouseId]);

  const loadWarehouse = async () => {
    try {
      const foundWarehouse = await warehouseApi.getWarehouse(warehouseId);
      console.log("🏢 WarehouseInventoryPage - API response:", foundWarehouse);
      console.log(
        "🏢 WarehouseInventoryPage - savedLocation:",
        foundWarehouse?.savedLocation
      );
      console.log(
        "🏢 WarehouseInventoryPage - savedLocation image:",
        foundWarehouse?.savedLocation?.image
      );
      setWarehouse(foundWarehouse);
    } catch (error) {
      console.error("Error loading warehouse:", error);
      message.error("Warehouse not found");
      history.push("/warehouses");
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    history.push("/warehouses");
  };

  if (loading) {
    return (
      <div className="warehouse-inventory-page loading-container">
        <Spin size="large" />
        <Text>Loading warehouse data...</Text>
      </div>
    );
  }

  if (!warehouse) {
    return (
      <div className="warehouse-inventory-page error-container">
        <Text>Warehouse not found</Text>
      </div>
    );
  }

  return (
    <div className="warehouse-inventory-page">
      <div className="breadcrumb-section">
        <div className="breadcrumbs">
          <span
            className="breadcrumb-item"
            onClick={handleBack}
            style={{ textDecoration: "none" }}
          >
            WAREHOUSES
          </span>
          <span className="breadcrumb-item" style={{ textDecoration: "none" }}>
            {warehouse.name?.toUpperCase()} INVENTORY
          </span>
        </div>
      </div>

      {/* Warehouse Info Header */}
      <div className="warehouse-header">
        <div className="warehouse-image-container">
          {warehouse.savedLocation?.image?.url || warehouse.image ? (
            <img
              src={warehouse.savedLocation?.image?.url || warehouse.image}
              alt={warehouse.name}
              className="warehouse-detail-image"
              style={{
                width: "200px",
                height: "200px",
                objectFit: "cover",
                borderRadius: "8px"
              }}
              onError={(e) => {
                // If image fails to load, hide and show placeholder
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "flex";
              }}
            />
          ) : null}
          <div
            className="warehouse-detail-placeholder"
            style={{
              display:
                warehouse.savedLocation?.image?.url || warehouse.image ? "none" : "flex",
              width: "200px",
              height: "200px",
              backgroundColor: "#f0f0f0",
              borderRadius: "8px",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "60px",
              border: "1px solid #d9d9d9"
            }}
          >
            🏢
          </div>
        </div>
        <div className="warehouse-info">
          <Title level={3} className="warehouse-title">
            {warehouse.name} - Inventory
            {warehouse.category && (
              <Text
                type="secondary"
                style={{ fontSize: "16px", fontWeight: "normal", marginLeft: "12px" }}
              >
                ({warehouse.category})
              </Text>
            )}
          </Title>
          <Text type="secondary" className="warehouse-location">
            {warehouse.savedLocation?.address || warehouse.address}
          </Text>
          <div style={{ marginTop: "8px" }}>
            <Button
              type="link"
              icon={<SettingOutlined />}
              onClick={() =>
                history.push(`/warehouses/settings?returnTo=/warehouses/${warehouseId}`)
              }
              style={{ padding: "0", height: "auto" }}
            >
              settings
            </Button>
          </div>
        </div>
      </div>

      {/* Inventory Management - Using existing component */}
      <div className="inventory-content">
        <WarehouseInventoryManagerWrapper
          warehouse={warehouse}
          warehouseId={warehouseId}
        />
      </div>
    </div>
  );
};

// Wrapper component to inject warehouse context into existing inventory manager
const WarehouseInventoryManagerWrapper = ({ warehouse, warehouseId }) => {
  return (
    <div className="warehouse-scoped-inventory">
      <WarehouseInventoryManager warehouseId={warehouseId} warehouse={warehouse} />
    </div>
  );
};

export default WarehouseInventoryPage;
